<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00030" title="[41]"><a id="Page_41"></a></span></p>
<h2 id="ANDERSONVILLE">ANDERSONVILLE.</h2>
</div>
<div class="blockquot">
<p class="calibre3">ARRIVAL AT THE WORST OF ALL PRISONS—BEGINNING OF A SUMMER
THAT KILLED THIRTEEN THOUSAND MEN—BAD WATER, BAD FOOD,
AND MOST INHUMAN TREATMENT—IN THE CLUTCHES OF WIRTZ
AND HIS PICKED OUT REBEL AIDS—THE TRUTH AND NOTHING BUT
THE TRUTH—A SEASON OF INTENSE SUFFERING.</p>
</div>
<p class="calibre3"><span class="smcap">Camp Sumpter</span>, Andersonville, Ga., March 14.—Arrived at our
destination at last and a dismal hole it is, too. We got off the
cars at two o’clock this morning in a cold rain, and were marched
into our pen between a strong guard carrying lighted pitch pine
knots to prevent our crawling off in the dark. I could hardly walk
have been cramped up so long, and feel as if I was a hundred
years old. Have stood up ever since we came from the cars, and
shivering with the cold. The rain has wet us to the skin and we
are worn out and miserable. Nothing to eat to-day, and another
dismal night just setting in.</p>
<p class="calibre3">March 15.—At about midnight I could stand up no longer, and
lay down in the mud and water. Could hardly get up. Shall get
food this morning, and after eating shall feel better. There is a
good deal to write about here, but I must postpone it until some
future time, for I can hardly hold a pencil now. <span class="smcap">Later</span>: Have
drawn some rations which consisted of nearly a quart of corn-meal,
half a pound of beef, and some salt. This is splendid. I have just
partaken of a delicious repast and feel like a different person. Dr.
Lewis is discouraged and thinks he cannot live long in such a place
as this.</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00031" title="[42]"><a id="Page_42"></a></span></p>
<p class="calibre3">March 16.—The prison is not yet entirely completed. One side
is yet open, and through the opening two pieces of artillery are
pointed. About 1800 Yankees are here now. Col. Piersons commands
the prison, and rides in and talks with the men. Is quite
sociable, and says we are all to be exchanged in a few weeks. He
was informed that such talk would not go down any longer. We
had been fooled enough, and paid no attention to what they told
us. Our mess is gradually settling down. Have picked out our
ground, rolled some big logs together, and are trying to make ourselves
comfortable. I am in the best of spirits, and will live with
them for some time to come if they will only give me one-quarter
enough to eat, and they are doing it now, and am in my glory.
Weather cleared up, and very cold nights. We put on all our
clothes nights and take them off day-times. The men do most of
their sleeping through the day, and shiver through the long nights.</p>
<p class="calibre3">March 17.—Get almost enough to eat, such as it is, but don’t
get it regularly; sometimes in the morning, and sometimes in the
afternoon. Six hundred more prisoners came last night, and from
Belle Isle, Va., our old home. Andersonville is situated on two
hillsides, with a small stream of swampy water running through
the center, and on both sides of the stream is a piece of swamp with
two or three acres in it. We have plenty of wood now, but it will
not last long. They will undoubtedly furnish us with wood from
the outside, when it is burned up on the inside. A very unhealthy
climate. A good many are being poisoned by poisonous roots, and
there is a thick green scum on the water. All who drink freely are
made sick, and their faces swell up so they cannot see.</p>
<p class="calibre3">March 18.—There are about fifteen acres of ground enclosed in
the stockade and we have the freedom of the whole ground. Plenty
of room, but they are filling it up. Six hundred new men coming
each day from Richmond. Guards are perched upon top of
the stockade; are very strict, and to-day one man was shot for
approaching too near the wall. A little warm to-day. Found W.
B. Rowe, from Jackson, Mich.; he is well and talks encouraging.
We have no shelter of any kind whatever. Eighteen or twenty die
per day. Cold and damp nights. The dews wet things through
completely, and by morning all nearly chilled. Wood getting
scarce. On the outside it is a regular wilderness of pines. Railroad
a mile off and can just see the cars as they go by, which is
the only sign of civilization in sight. Rebels all the while at work
making the prison stronger. Very poor meal, and not so much to-day<span class="x-ebookmaker-pageno" id="pgepubid00032" title="[43]"><a id="Page_43"></a></span>
as formerly. My young friend Billy Havens was sent to the
hospital about the time we left Richmond. Shall be glad to hear
of his recovery. Prevailing conversation is food and exchange.</p>
<p class="calibre3">March 19.—A good deal of fighting going on among us. A large
number of sailors and marines are confined with us, and they are a
quarrelsome set. I have a very sore hand, caused by cutting a
hole through the car trying to get out. I have to write with my
left hand. It is going to be an awful place during the summer
months here, and thousands will die no doubt.</p>
<p class="calibre3">March 21.—Prison gradually filling up with forlorn looking creatures.
Wood is being burned up gradually. Have taken in my old
acquaintance and a member of my own company “A” 9th Mich.
Cavalry, Wm. B. Rowe. Sergt. Rowe is a tall, straight, dark complexioned
man, about thirty-five years old. He was captured while
carrying dispatches from Knoxville to Gen. Burnside. Has been a
prisoner two or three months, and was in Pemerton Building until
sent here. He is a tough, able-bodied man. Every day I find
new Michigan men, some of them old acquaintances.</p>
<p class="calibre3">March 23.—Stockade all up, and we are penned in. Our mess
is out of filthy lucre—otherwise, busted. Sold my overcoat to a
guard, and for luxuries we are eating that up. My blanket keeps
us all warm. There are two more in our mess. Daytimes the large
spread is stretched three or four feet high on four sticks, and keeps
off the sun, and at night taken down for a cover.</p>
<p class="calibre3">March 24.—Digging a tunnel to get out of this place. Prison
getting filthy. Prisoners somewhat to blame for it. Good many
dying, and they are those who take no care of themselves, drink
poor water, etc.</p>
<p class="calibre3">March 25.—Lieut. Piersons is no longer in command of the prison,
but instead a Capt. Wirtz. Came inside to-day and looked us
over. Is not a very prepossessing looking chap. Is about thirty-five
or forty years old, rather tall, and a little stoop shouldered;
skin has a pale, white livered look, with thin lips. Has a sneering
sort of cast of countenance. Makes a fellow feel as if he would
like to go up and boot him. Should judge he was a Swede, or
some such countryman. Hendryx thinks he could make it warm
for him in short order if he only had a chance. Wirtz wears
considerable jewelry on his person—long watch chain, something
that looks like a diamond for a pin in his shirt, and wears patent
leather boots or shoes. I asked him if he didn’t think we would
be exchanged soon. He said: Oh, yes, we would be exchanged<span class="x-ebookmaker-pageno" id="pgepubid00033" title="[44]"><a id="Page_44"></a></span>
soon. Somehow or other this assurance don’t elate us much; perhaps
it was his manner when saying it. Andersonville is getting
to be a rather bad place as it grows warmer. Several sick with
fevers and sores.</p>
<p class="calibre3">March 26.—Well, well, my birthday came six days ago, and how
old do you think I am? Let me see. Appearances would seem to
indicate that I am thirty or thereabouts, but as I was born on the
20th day of March, 1843, I must now be just twenty-one years of
age, this being the year 1864. Of age and six days over. I thought
that when a man became of age, he generally became free and his
own master as well. If this ain’t a burlesque on that old time-honored
custom, then carry me out—but not feet foremost.</p>
<p class="calibre3">March 27.—We have issued to us once each day about a pint of
beans, or more properly peas, (full of bugs), and three-quarters of a
pint of meal, and nearly every day a piece of bacon the size of your
two fingers, probably about three or four ounces. This is very
good rations taken in comparison to what I have received before.
The pine which we use in cooking is pitch pine, and a black smoke
arises from it; consequently we are black as negroes. Prison gradually
filling from day to day, and situation rather more unhealthy.
Occasionally a squad comes in who have been lately captured,
and they tell of our battles, sometimes victorious and sometimes
otherwise. Sometimes we are hopeful and sometimes the reverse.
Take all the exercise we can, drink no water, and try to get along.
It is a sad sight to see the men die so fast. New prisoners die the
quickest and are buried in the near vicinity, we are told in trenches
without coffins. Sometimes we have visitors of citizens and women
who come to look at us. There is sympathy in some of their faces
and in some a lack of it. A dead line composed of slats of boards
runs around on the inside of the wall, about twelve or fourteen feet
from the wall, and we are not allowed to go near it on pain of being
shot by the guard.</p>
<p class="calibre3">March 28.—We are squadded over to-day, and rations about to
come in. It’s a sickly dirty place. Seems as if the sun was not
over a mile high, and has a particular grudge against us. Wirtz
comes inside and has began to be very insolent. Is constantly
watching for tunnels. He is a brute. We call him the “Flying
Dutchman.” Came across Sergt. Bullock, of my regiment, whom
I last saw on Belle Isle. From a fat, chubby young fellow, he is a
perfect wreck. Lost his voice and can hardly speak aloud; nothing
but skin and bone, and black and ragged. Never saw such a<span class="x-ebookmaker-pageno" id="pgepubid00034" title="[45]"><a id="Page_45"></a></span>
change in a human being. Cannot possibly live, I don’t think; still
he is plucky and hates to die. Goes all around enquiring for news,
and the least thing encouraging cheers him up. Capt. Moseby, of
the raiders, is in the same squad with me. He is quite an intelligent
fellow and often talks with us. We lend him our boiling cup
which he returns with thanks. Better to keep on the right side of
him, if we can without countenancing his murderous operations.</p>
<p class="calibre3">March 29.—Raiders getting more bold as the situation grows
worse. Often rob a man now of all he has, in public, making no
attempt at concealment. In sticking up for the weaker party, our
mess gets into trouble nearly every day, and particularly Hendryx,
who will fight any time.</p>
<p class="calibre3">March 30.—The gate opens every little while letting some poor
victims into this terrible place, which is already much worse than
Belle Isle. Seems as if our government is at fault in not providing
some way to get us out of here. The hot weather months must kill
us all outright. Feel myself at times sick and feverish with no
strength seemingly. Dr. Lewis worries, worries, all the day long,
and it’s all we can do to keep him from giving up entirely. Sergt.
Rowe takes things as they come in dogged silence. Looks like a
caged lion. Hendryx sputters around, scolding away, &amp;c.</p>
<p class="calibre3">April 1.—This is an April Fool sure. Saw a fellow to-day from
our regiment, named Casey. Says I was reported dead at the regiment,
which is cheerful. Perhaps it is just as well though, for
them to anticipate the event a few months. It is said that Wirtz
shot some one this morning. Often hear the guards shoot and hear
of men being killed. Am not ambitious to go near them. Have
completely lost my desire to be on the outside working for extra
rations. Prefer to stick it out where I am than to have anything
to do with them. They are an ungodly crew, and should have the
warmest corner in that place we sometimes hear mentioned.</p>
<p class="calibre3">April 2—James Robins, an Indiana soldier, is in our close proximity.
Was wounded and taken prisoner not long since. Wound,
which is in the thigh, is in a terrible condition, and gangrene setting
in. Although he was carried to the gate to-day, was refused
admission to the hospital or medical attendance. Rebels say they
have no medicine for us. Robins has been telling me about
himself and family at home, and his case is only one of a great
many good substantial men of families who must die in Southern
prisons, as victims to mismanagement. The poorer the Confederacy,
and the meaner they are, the more need that our government<span class="x-ebookmaker-pageno" id="pgepubid00035" title="[46]"><a id="Page_46"></a></span>
should get us away from here, and not put objectionable men at
the head of exchange to prevent our being sent home or back to
our commands.</p>
<p class="calibre3">April 3—We have stopped wondering at suffering or being surprised
at anything. Can’t do the subject justice and so don’t try.
Walk around camp every morning looking for acquaintances, the
sick, &amp;c. Can see a dozen most any morning laying around dead.
A great many are terribly afflicted with diarrhea and scurvy begins
to take hold of some. Scurvy is a bad disease, and taken in connection
with the former is sure death. Some have dropsy as well
as scurvy, and the swollen limbs and body are sad to see. To think
that these victims have people at home, mothers, wives and sisters,
who are thinking of them and would do much for them if they had
the chance, little dreaming of their condition.</p>
<p class="calibre3">April 4.—Same old story—coming in and being carried out;
all have a feeling of lassitude which prevents much exertion. Have
been digging in a tunnel for a day or two with a dozen others who
are in the secret. It’s hard work. A number of tunnels have been
discovered. The water now is very warm and sickening.</p>
<p class="calibre3">April 5.—Dr. Lewis talks about nothing except his family. Is
the bluest mortal here, and worries himself sick, let alone causes
sufficient for that purpose. Is poorly adapted for hardships. For
reading we have the “Pilgrim’s Progress,” donated to me by some
one when on Belle Isle. Guess I can repeat nearly all the book by
heart. Make new acquaintances every day. “Scotty,” a marine,
just now is edifying our mess with his salt water yarns, and they
are tough ones. I tell him he may die here; still he declares they
are true.</p>
<p class="calibre3">April 6—John Smith is here and numerous of his family. So
many go by nick-names, that seldom any go by their real names.
Its “Minnesota,” “Big Charlie,” “Little Jim,” “Marine Jack,”
“Indiana Feller,” “Mopey,” “Skinny,” “Smarty,” &amp;c. Hendryx
is known by the latter name, Sanders is called “Dad,” Rowe is
called the “Michigan Sergeant,” Lewis is called plain “Doc.”
while I am called, for some unknown reason, “Bugler.” I have
heard it said that I looked just like a Dutch bugler, and perhaps
that is the reason of my cognomen. Probably thirty die per day.
The slightest news about exchange is told from one to the other,
and gains every time repeated, until finally its grand good news and
sure exchange immediately. The weak ones feed upon these reports<span class="x-ebookmaker-pageno" id="pgepubid00036" title="[47]"><a id="Page_47"></a></span>
and struggle along from day to day. One hour they are all
hope and expectation and the next hour as bad the other way. The
worst looking scallawags perched upon the stockade as guards, from
boys just large enough to handle a gun, to old men who ought to
have been dead years ago for the good of their country. Some
prisoners nearly naked, the majority in rags and daily becoming
more destitute. My clothes are good and kept clean, health fair
although very poor in flesh. Man killed at the dead line.</p>
<p class="calibre3">April 7.—Capt. Wirtz prowls around the stockade with a rebel
escort of guards, looking for tunnels. Is very suspicious of amateur
wells which some have dug for water. It is useless to speak
to him about our condition, as he will give us no satisfaction whatever.
Says it is good enough for us —— yankees. I am deputized
by half a dozen or so to speak to him as to the probabilities
of a change, and whether we may not reasonably expect to be exchanged
without passing the summer here. In his position he must
know something in relation to our future. At the first favorable
moment shall approach his highness. Prison is all the time being
made stronger, more guards coming and artillery looking at us
rather unpleasantly from many directions. Think it impossible for
any to get away here, so far from our lines. The men too are not
able to withstand the hardships attendant upon an escape, still
fully one-half of all here are constantly on the alert for chances to
get away. Foremost in all schemes for freedom is Hendryx, and
we are engaging in a new tunnel enterprise. The yankee is a curious
animal, never quiet until dead. There are some here who pray and
try to preach. Very many too who have heretofore been religiously
inclined, throw off all restraint and are about the worst.
Tried and found wanting it seems to me. Those who find the least
fault, make the best of things as they come and grin and bear it,
get along the best. Weather getting warmer, water warmer and
nastier, food worse and less in quantities, and more prisoners coming
nearly every day.</p>
<p class="calibre3">April 8.—We are digging with an old fire shovel at our tunnel.
The shovel is a prize; we also use half of canteens, pieces of boards,
&amp;c. Its laborious work. A dozen are engaged in it. Like going
into a grave to go into a tunnel. Soil light and liable to cave in.
Take turns in digging. Waste dirt carried to the stream in small
quantities and thrown in. Not much faith in the enterprise, but
work with the rest as a sort of duty. Raiders acting fearful. Was
boiling my cup of meal to-day and one of the raiders ran against<span class="x-ebookmaker-pageno" id="pgepubid00037" title="[48]"><a id="Page_48"></a></span>
it and over it went. Give him a whack side of the head that made
him see stars I should judge, and in return he made me see the
whole heavens. Battese, a big Indian, rather helped me out of the
scrape. All of our mess came to my rescue. Came near being a
big fight with dozens engaged. Battese is a large full blooded six
foot Minnesota Indian, has quarters near us, and is a noble fellow.
He and other Indians have been in our hundred for some weeks.
They are quiet, attend to their own business, and won’t stand much
nonsense. Great deal of fighting. One Duffy, a New York rough,
claims the light weight championship of Andersonville. Regular
battles quite often. Remarkable how men will stand up and be
pummeled. Dr. Lewis daily getting worse off. Is troubled with
scurvy and dropsy. If he was at home would be considered dangerously
ill and in bed, but he walks around slowly inquiring for
news in a pitiful way. I have probably fifty acquaintances here
that visit us each day to talk the situation over. Jimmy Devers,
my Michigan friend whom I found on Belle Isle, Sergt. Bullock, of
my regiment; Tom McGill, also of Michigan; Michael Hoare, a
schoolmate of mine from earliest recollection, Dorr Blakeman, also
a resident of Jackson, Michigan, a little fellow named Swan, who
lived in Ypsylanti, Mich.; Burckhardt from near Lansing; Hub
Dakin, from Dansville, Mich., and many others, meet often to
compare notes, and we have many a hearty laugh in the midst of
misery. I dicker and trade and often make an extra ration. We
sometimes draw small cow peas for rations, and being a printer by
trade, I spread the peas out on a blanket and quickly pick them up
one at a time, after the manner of picking up type. One drawback
is the practice of unconsciously putting the beans into my
mouth. In this way I often eat up the whole printing office. I
have trials of skill with a fellow named Land, who is also a printer.
There are no other typos here that I know of.</p>
<p class="calibre3">April 9.—See here Mr. Confederacy, this is going a little too far.
You have no business to kill us off at this rate. About thirty or
forty die daily. They have rigged up an excuse for a hospital
on the outside, where the sick are taken. Admit none though who
can walk or help themselves in any way. Some of our men are detailed
to help as nurses, but in a majority of cases those who go out
on parole of honor are cut-throats and robbers, who abuse a sick
prisoner. Still, there are exceptions to this rule. We hear stories
of Capt. Wirtz’s cruelty in punishing the men, but I hardly credit
all the stories. More prisoners to-day. Some captured near Petersburg.<span class="x-ebookmaker-pageno" id="pgepubid00038" title="[49]"><a id="Page_49"></a></span>
Don’t know anything about exchange. Scurvy and dropsy
taking hold of the men. Many are blind as soon as it becomes
night, and it is called moon blind. Caused, I suppose, by sleeping
with the moon shining in the face. Talked with Michael Hoare,
an old school fellow of mine. Mike was captured while we were in
Pemerton Building, and was one of Dahlgreen’s men. Was taken
right in the suburbs of Richmond. Has told me all the news of
their failure on account of Kilpatrick failing to make a junction at
some point. Mike is a great tall, slim fellow, and a good one.
Said he heard my name called out in Richmond as having a box of
eatables from the North. He also saw a man named Shaw claim
the box with a written order from me, Shaw was one of our mess
on Belle Isle. He was sent to Richmond while sick, from the
island, knew of my expecting the box, and forged an order to get
it. Well, that was rough, still I probably wouldn’t have got it any
way. Better him than some rebel. Mike gave me a lot of black
pepper which we put into our soup, which is a luxury. He has no
end of talk at his tongue’s end, and it is good to hear. Recounts
how once when I was about eight or ten years old and he some
older, I threw a base ball club and hit him on the shins. Then ran
and he couldn’t catch me. It was when we were both going to
school to A. A. Henderson, in Jackson, Mich. Think I remember
the incident, and am strongly under the impression that he caught
me. It is thus that old friends meet after many years. John McGuire
is also here, another Jackson man. He has a family at home
and is worried. Says he used to frequently see my brother George
at Hilton Head, before being captured.</p>
<p class="calibre3">April 10.—Getting warmer and warmer. Can see the trees swaying
back and forth on the outside, but inside not a breath of fresh
air. Our wood is all gone, and we are now digging up stumps and
roots for fuel to cook with. Some of the first prisoners here have
passable huts made of logs, sticks, pieces of blankets, &amp;c. Room
about all taken up in here now. Rations not so large. Talk that
they intend to make the meal into bread before sending it inside,
which will be an improvement. Rations have settled down to less
than a pint of meal per day, with occasionally a few peas, or an
apology for a piece of bacon, for each man. Should judge that
they have hounds on the outside to catch runaways, from the
noise. Wirtz don’t come in as much as formerly. The men make
it uncomfortable for him. As Jimmy Devers says, “He is a terror.”
I have omitted to mention Jimmy’s name of late, although<span class="x-ebookmaker-pageno" id="pgepubid00039" title="[50]"><a id="Page_50"></a></span>
he is with us all the time—not in our mess, but close by. He has
an old pack of cards with which we play to pass away the time.
Many of the men have testaments, and “house-wives” which they
have brought with them from home, and it is pitiful to see them
look at these things while thinking of their loved ones at home.</p>
<p class="calibre3">April 11.—Dr. Lewis is very bad off with the scurvy and diarrhea.
We don’t think he can stand it much longer, but make out
to him that he will stick it through. Our government must hear
of our condition here and get us away before long. If they don’t,
its a poor government to tie to. Hendryx and myself are poor, as
also are all the mess. Still in good health compared with the generality
of the prisoners. Jimmy Devers has evidently sort of dried
up, and it don’t seem to make any difference whether he gets anything
to eat or not. He has now been a prisoner of war nearly a
year, and is in good health and very hopeful of getting away in
time. Sticks up for our government and says there is some good
reason for our continued imprisonment. I can see none. As many
as 12,000 men here now, and crowded for room. Death rate is in
the neighborhood of eighty per day. Hendryx prowls around all
over the prison, bringing us what good news he can, which is not
much. A very heavy dew nights, which is almost a rain. Rebels
very domineering. Many are tunneling to get out. Our tunnel
has been abandoned, as the location was not practicable. Yank
shot to-day near our quarters. Approached too near the dead line.
Many of the men have dug down through the sand and reached
water, but it is poor; no better than out of the creek.</p>
<p class="calibre3">April 12.—Another beautiful but warm day with no news. Insects
of all descriptions making their appearance, such as lizards,
a worm four or five inches long, fleas, maggots &amp;c. There is so
much filth about the camp that it is terrible trying to live here.
New prisoners are made sick the first hours of their arrival by the
stench which pervades the prison. Old prisoners do not mind it so
much, having become used to it. No visitors come near us any
more. Everybody sick, almost, with scurvy—an awful disease.
New cases every day. I am afraid some contagious disease will get
among us, and if so every man will die. My blanket a perfect God-send.
Is large and furnishes shelter from the burning sun. Hendryx
has a very sore arm which troubles him much. Even he
begins to look and feel bad. James Gordan, or Gordenian, (I don’t
know which) was killed to-day by the guard. In crossing the creek
on a small board crossway men are often shot. It runs very near<span class="x-ebookmaker-pageno" id="pgepubid00040" title="[51]"><a id="Page_51"></a></span>
the dead line, and guards take the occasion to shoot parties who
put their hands on the dead line in going across. Some also reach
up under the dead line to get purer water, and are shot. Men
seemingly reckless of their lives. New prisoners coming in and
are shocked at the sights.</p>
<p class="calibre3">April 13.—Jack Shannon, from Ann Arbor, died this morning.
The raiders are the stronger party now, and do as they please; and
we are in nearly as much danger now from our own men as from
the rebels. Capt. Moseby, of my own hundred, figures conspicuously
among the robberies, and is a terrible villain. During the
night some one stole my jacket. Have traded off all superfluous
clothes, and with the loss of jacket have only pants, shirt, shoes,
(no stockings,) and hat; yet I am well dressed in comparison with
some others. Many have nothing but an old pair of pants which
reach, perhaps, to the knees, and perhaps not. Hendryx has two
shirts, and should be mobbed. I do quite a business trading rations,
making soup for the sick ones, taking in payment their raw food
which they cannot eat. Get many a little snack by so doing.</p>
<p class="calibre3">April 14.—At least twenty fights among our own men this forenoon.
It beats all what a snarling crowd we are getting to be.
The men are perfectly reckless, and had just as soon have their
necks broken by fighting as anything else. New onions in camp.
Very small, and sell for $2 a bunch of four or five. Van Tassel, a
Pennsylvanian, is about to die. Many give me parting injunctions
relative to their families, in case I should live through. Have half
a dozen photographs of dead men’s wives, with addresses on the
back of them. Seems to be pretty generally conceded that if any
get through, I will. Not a man here now is in good health. An
utter impossibility to remain well. Signs of scurvy about my person.
Still adhere to our sanitary rules. Lewis anxious to get to
the hospital. Will die any way shortly, whether there or here.
Jimmy Devers, the old prisoner, coming down. Those who have
stood it bravely begin to weaken.</p>
<p class="calibre3">April 15.—The hospital is a tough place to be in, from all
accounts. The detailed Yankees as soon as they get a little authority
are certain to use it for all it is worth. In some cases before a
man is fairly dead, he is stripped of everything, coat, pants, shirt,
finger rings (if he has any), and everything of value taken away.
These the nurses trade to the guards. Does not seem possible but
such is the case, sad to relate. Not very pleasant for a man just
breathing his last, and perhaps thinking of loved ones at home who<span class="x-ebookmaker-pageno" id="pgepubid00041" title="[52]"><a id="Page_52"></a></span>
are all so unconscious of the condition of their soldier father or
brother, to be suddenly jerked about and fought over, with the
cursing and blaspheming he is apt to hear. The sick now, or a
portion of them, are huddled up in one corner of the prison,
to get as bad as they can before being admitted to the outside hospital.
Every day I visit it, and come away sick at heart that
human beings should be thus treated.</p>
<p class="calibre3">April 26.—Ten days since I wrote in my diary, and in those ten
days was too much occupied in trying to dig a tunnel to escape
out of, to write any. On the 21st the tunnel was opened and two
fellows belonging to a Massachusetts regiment escaped to the outside.
Hendryx and myself next went out. The night was very
dark. Came up out of the ground away on the outside of the
guard. We crawled along to gain the woods, and get by some
pickets, and when forty or fifty rods from the stockade, a shot was
fired at some one coming out of the hole. We immediately jumped
up and ran for dear life, seemingly making more noise than a troop
of cavalry. It was almost daylight and away we went. Found I
could not run far and we slowed up, knowing we would be caught,
but hoping to get to some house and get something to eat first.
Found I was all broke up for any exertion. In an hour we had
traveled perhaps three miles, were all covered with mud, and
scratched up. I had fell, too, in getting over some logs, and it
seemed to me broken all the ribs in my body. Just as it was coming
light in the east we heard dogs after us. We expected it, and
so armed ourselves with clubs and sat down on a log. In a few moments
the hounds came up with us and began smelling of us.
Pretty soon five mounted rebels arrived on the scene of action.
They laughed to think we expected to get away. Started us back
towards our charnel pen. Dogs did not offer to bite us, but guards
told us that if we had offered resistance or started to run they
would have torn us. Arrived at the prison and after waiting an
hour Capt. Wirtz interviewed us. After cussing us a few minutes
we were put in the chain gang, where we remained two days. This
was not very fine, but contrary to expectation not so bad after all.
We had more to eat than when inside, and we had shade to lay in,
and although my ancles were made very sore, do not regret my
escapade. Am not permanently hurt any. We had quite an allowance
of bacon while out, and some spring water to drink. Also
from the surgeon I got some elder berries to steep into a tea to
drink for scurvy, which is beginning to take hold of me. Lewis is<span class="x-ebookmaker-pageno" id="pgepubid00042" title="[53]"><a id="Page_53"></a></span>
sick and can hardly walk around. His days are few. Have taken
another into our mess, named Swan, from Ypsilanti, Michigan. Is
a fresh looking boy for this place and looks like a girl.</p>
<p class="calibre3">April 27.—Well, I was out from under rebel guard for an hour
or so any way. Hurt my side though, and caught a little cold. Am
sore somewhat. Have given up the idea of escaping. Think if
Hendryx had been alone he would have gotten away. Is tougher
than I am. A man caught stealing from one of his comrades and
stabbed with a knife and killed. To show how little such things
are noticed here I will give the particulars as near as I could get
them. There were five or six men stopping together in a sort of
shanty. Two of them were speculators, and had some money,
corn bread, &amp;c., and would not divide with their comrades, who
belonged to their own company and regiment. Some time in the
night one of them got up and was stealing bread from a haversack
belonging to his more prosperous neighbor, and during the operation
woke up the owner, who seized a knife and stabbed the poor
fellow dead. The one who did the murder spoke out and said:
“Harry, I believe Bill is dead; he was just stealing from me and I
run my knife into him.” “Good enough for him,” says Harry.
The two men then got up and straightened out “Bill,” and then
both lay down and went to sleep. An occupant of the hut told me
these particulars and they are true. This morning poor Bill lay in
the hut until eight or nine o’clock, and was then carried outside.
The man who did the killing made no secret of it, but told it to all
who wanted to know the particulars, who were only a few, as the
occurrence was not an unusual one.</p>
<p class="calibre3">April 28.—Dr. Lewis is still getting worse with scurvy and dropsy
combined. Limbs swollen to double their usual size—just like
puff-balls. Raiders do about as they please, and their crimes would
fill more paper than I have at my disposal.</p>
<p class="calibre3">April 30.—Very small rations given to us now. Not more than
one-quarter what we want to eat and that of the poorest quality.
Splendid weather, but too warm; occasional rains. The Flying
Dutchman (Wirtz) offers to give any two at a time twelve hours the
start, and if caught to take the punishment he has for runaways.
The offer is made to intimidate those thinking to escape. Half the
men would take the consequences with two hours start.</p>
<p class="calibre3">May 1.—Warm. Samuel Hutton, of the 9th Mich. Cavalry,
died last night; also Peter Christiancy and Joseph Sargent, of Co.
D, 9th Mich., have died within a few weeks. Last evening 700 of<span class="x-ebookmaker-pageno" id="pgepubid00043" title="[54]"><a id="Page_54"></a></span>
the 85th New York arrived here. They were taken at Plymouth,
N.C., with 1,400 others, making 2,100 in all. The balance are on
the road to this place. Wrote a letter home to-day. Have not
heard from the North for over six months. Dying off very fast.</p>
<p class="calibre3">May 2.—A crazy man was shot dead by the guard an hour ago.
The guard dropped a piece of bread on the inside of the stockade,
and the fellow went inside the dead line to get it and was killed.
The bread wagon was raided upon as soon as it drove inside to-day
and all the bread stolen, for which offense no more will be issued
to-day. As I write Wirtz is walking about the prison revolver in
hand, cursing and swearing. The men yell out “Hang him up!”
“Kill the Dutch louse!” “Buck and gag him!” “Stone him to
death!” &amp;c., and he all the time trying to find out who it is insulting
him so. “I vish I find out who calls me such insulting vords, I
kill the dam Yankee as soon I eat my supper!” And every few
minutes a handful of dirt is thrown by some one. Wreaks his vengeance
by keeping back rations from the whole camp.</p>
<p class="calibre3">May 3.—A rebel battery came to-day on the cars, and is being
posted around the stockade. Ever since my introduction to Andersonville
they have been constantly at work making their prison
stronger, until now I believe it is impossible for a person to get
away. Notwithstanding, there are men all the time at work in
divers ways. Rebel officers now say that we are not going to be
exchanged during the war, and as they can hold us now and no
fear of escape, they had just as soon tell us the truth as not, and
we must take things just as they see fit to give them to us. Tom
McGill is well and hearty, and as black as any negro. Over 19,000
confined here now, and the death rate ninety or one hundred.</p>
<p class="calibre3">May 4.—Good weather. Gen. Howell Cobb and staff came
among us to-day, and inspected the prison. Wirtz accompanied
them pointing out and explaining matters. Gen. Winder, who has
charge of all the prisoners of war in the South, is here, but has not
been inside. Gen. Cobb is a very large and pompous looking man.
None of the men dare address his highness. Three men out of
every hundred allowed to go out after wood under a strong guard.</p>
<p class="calibre3">May 5.—Cold nights and warm days. Very unhealthy, such
extremes. Small-pox cases carried out, and much alarm felt lest it
should spread.</p>
<p class="calibre3">May 6.—Six months a prisoner to-day. Longer than any six
years of my previous life. It is wonderful how well I stand the
hardships here. At home I was not very robust, in fact had a tendency<span class="x-ebookmaker-pageno" id="pgepubid00044" title="[55]"><a id="Page_55"></a></span>
to poor health; but there are not many in prison that stand it
as well as I do. There are about eighty-five or ninety dying now
per day, as near as I can find out. Of course there are stories to the
effect that a hundred and fifty and two hundred die each day, but
such is not the case. Have a code of reasoning that is pretty correct.
Often wonder if I shall get home again, and come to the conclusion
that I shall. My hopeful disposition does more for me than
anything else. Sanders trades and dickers around and makes
extra eatables for our mess. There is not a hog in the mess. Nearly
every day some one is killed for some trifling offense, by the guards.
Rather better food to-day than usual.</p>
<p class="calibre3">May 7.—A squad of Yankees taken outside to-day on parole of
honor, for the purpose of baking meal into bread. George Hendryx
is one of the number, and he will have enough to eat after
this, which I am glad of. I could have gotten outside if I so chose,
but curious to write down I don’t want to go. George says he will
try and send in something for us to eat, and I know he will, for a
truer hearted fellow never lived.</p>
<p class="calibre3">May 8.—Awful warm and more sickly. About 3,500 have died
since I came here, which is a good many, come to think of it—cooked
rations of bread to-day. We get a quarter of a loaf of
bread, weighing about six ounces, and four or five ounces of pork.
These are small allowances, but being cooked it is better for us.
Rebels are making promises of feeding us better, which we hope
they will keep. There is nothing the matter with me now but lack
of food. The scurvy symptoms which appeared a few weeks ago
have all gone.</p>
<p class="calibre3">May 9.—Many rebels riding about camp on horseback. I listened
to an animated conversation between an officer and two of our
men. Mr. Rebel got talked all to pieces and hushed up entirely.
He took it good naturedly, however, and for a wonder did not
swear and curse us. It is a great treat to see a decent rebel. Am
lonesome since Hendryx went outside. Men are continually going
up to the dead line and getting shot. They do not get much
sympathy, as they should know better.</p>
<p class="calibre3">May 10.—Capt. Wirtz very domineering and abusive. Is afraid
to come into camp any more. There are a thousand men in here
who would willingly die if they could kill him first. Certainly the
worst man I ever saw. New prisoners coming in every day with
good clothes, blankets, &amp;c., and occasionally with considerable
money. These are victims for the raiders who pitch into them for<span class="x-ebookmaker-pageno" id="pgepubid00045" title="[56]"><a id="Page_56"></a></span>
plunder. Very serious fights occur. Occasionally a party of new
comers stick together and whip the raiders, who afterward rally
their forces and the affair ends with the robbers victorious. Stones,
clubs, knives, sling shots, &amp;c., are used on these occasions, and
sometimes the camp gets so stirred up that the rebels, thinking a
break is intended, fire into the crowds gathered, and many are
killed before quiet is again restored. Then Wirtz writes out an
order and sends inside, telling he is prepared for any break, etc.,
etc. No less than five have died within a radius of thirty feet in
the last twenty-four hours. Hendryx has a sore arm and in turning
over last night I hurt it. He pitched in to me while I was in a
sound sleep to pay me for it. Woke up in short order and we had
it, rough and tumble. Tore down the tent poles—rolled around—scaring
Lewis and all the rest. I am the stoutest, and soon get on
top and hold him down, and keep him there until he quiets down,
which is always in about five minutes. We have squabbles of this
sort often, which don’t do any particular harm. Always laugh,
shake and make up afterwards. The “Astor House Mess,” or the
heads rather, have gently requested that we do our fighting by daylight,
and Sanders very forcibly remarked that should another
scene occur as happened last night, he will take a hand in the business
and lick us both. Battese laughed, for about the first time
this summer. He has taken quite a shine to both Hendryx and
myself. In the fore part of to-day’s entry I should have stated that
Hendryx has been sent inside, they not being quite ready for him
at the cook-house. He is a baker by trade.</p>
<p class="calibre3">May 11.—Rainy weather and cold nights. Men shiver and cry
all night—groan and “holler.” I lay awake sometimes for hours,
listening to the guards yell out “Post number one; ten o’clock and
all’s well!” And then Post No. 2 takes up the refrain, and it goes
all around the camp, every one with a different sounding voice,
squeaky, coarse, and all sorts. Some of them drawl out “H-e-r-e-’s
y-e-r m-u-l-e!” and such like changes, instead of “All’s well.”
Rumors of hard fighting about Richmond, and the rebels getting
whipped, which of course they deny.</p>
<p class="calibre3">May 12.—Received a few lines from George Hendryx, who again
went out to work on the outside last night. Wirtz with a squad of
guards is about the camp looking for tunnels. Patrols also looking
among the prisoners for deserters. A lame man, for telling of
a tunnel, was pounded almost to death last night, and this morning
they were chasing him to administer more punishment, when he<span class="x-ebookmaker-pageno" id="pgepubid00046" title="[57]"><a id="Page_57"></a></span>
ran inside the dead line claiming protection of the guard. The
guard didn’t protect worth a cent, but shot him through the head.
A general hurrahing took place, as the rebel had only saved our
men the trouble of killing him. More rumors of hard fighting
about Richmond. Grant getting the best of it I reckon. Richmond
surrounded and rebels evacuating the place. These are the
rumors. Guards deny it.</p>
<p class="calibre3">May 13.—Rainy morning. We are guarded by an Alabama regiment,
who are about to leave for the front. Georgia militia to
take their places. Making preparations for a grand pic-nic outside,
given by the citizens of the vicinity to the troops about to leave. I
must here tell a funny affair that has happened to me, which,
although funny is very annoying. Two or three days before I was
captured I bought a pair of cavalry boots of a teamster named
Carpenter. The boots were too small for him and just fitted me.
Promised to pay him on “pay day,” we not having been paid off in
some time. We were both taken prisoners and have been in the
same hundred ever since. Has dunned me now about 1,850 times,
and has always been mad at not getting his pay. Sold the boots
shortly after being captured and gave him half the receipts, and
since that have paid him in rations and money as I could get it,
until about sixty cents remain unpaid, and that sum is a sticker.
He is my evil genius, and fairly haunts the life out of me. Whatever
I may get trusted for in after life, it shall never be for a pair
of boots. Carpenter is now sick with scurvy, and I am beginning
to get the same disease hold of me again. Battese cut my hair
which was about a foot long. Gay old cut. Many have long hair,
which, being never combed, is matted together and full of vermin.
With sunken eyes, blackened countenances from pitch pine smoke,
rags and disease, the men look sickening. The air reeks with nastiness,
and it is wonder that we live at all. When will relief come
to us?</p>
<p class="calibre3">May 14.—A band of music came from Macon yesterday to attend
the pic-nic. A large crowd of women were present to grace the
occasion. The grounds on which the festivities were held lay a
mile off and in sight of all. In the evening a Bowery dance was
one of the pleasures enjoyed. “The Girl I Left Behind Me,” was
about all they could play, and that very poorly.</p>
<p class="calibre3">May 15.—Sabbath day and hot. Would give anything for some
shade to lay in. Even this luxury is denied us, and we are obliged<span class="x-ebookmaker-pageno" id="pgepubid00047" title="[58]"><a id="Page_58"></a></span>
to crawl around more dead than alive. Rumors that Sherman is
marching towards Atlanta, and that place threatened. Kilpatrick
said to be moving toward us for the purpose of effecting our release.
Hope he will be more successful than in his attack on Richmond.
Rebels have dug a deep ditch all around on the outside of the wall
to prevent tunneling, and a guard walks in the bottom of the ditch.
Banghart, of my Regiment, died to-day.</p>
<p class="calibre3">May 16.—Two men got away during the night and were brought
back before noon. (Was going to say before dinner.) The men
are torn by the dogs, and one of them full of buck shot. A funny
way of escape has just been discovered by Wirtz. A man pretends
to be dead and is carried out on a stretcher and left with the row of
dead. As soon as it gets dark, Mr. Dead-man jumps up and runs.
Wirtz suspecting the trick took to watching, and discovered a
“dead man” running away. An examination now takes place by
the surgeon before being permitted out from under guard. I hear
a number of men have gotten away by this method, and it seems
very probable, as dead men are so plenty that not much attention
is paid to them.</p>
<p class="calibre3">May 17.—Had a funny dream last night. Thought the rebels
were so hard up for mules that they hitched up a couple of grayback
lice to draw in the bread. Wirtz is watching out for Yankee
tricks. Some one told him the other day that the Yankees were
making a large balloon inside and some day would all rise up in the
air and escape. He flew around as if mad, but could find no signs
of a balloon. Says there is no telling what “te tam Yankee will
do.” Some prisoners came to-day who were captured at Dalton,
and report the place in our possession, and the rebels driven six
miles this side. Kilpatrick and Stoneman are both with Sherman
and there are expectations of starting out on some mission soon,
supposed to be for this place. Nineteen thousand confined here
now and dying at the rate of ninety per day. Philo Lewis, of the
5th Michigan Cav., can live but a day or two. Talks continually
of his wife and family in Ypsilanti, Mich. Has pictures of the
whole family, which he has given me to take home to them, also a
long letter addressed to his wife and children. Mr. Lewis used to
be a teacher of singing in Ypsilanti. He is a fine looking man naturally,
and a smart man, but he must go the way of thousands of
others, and perhaps myself. One of his pupils is here confined.
Philo Lewis must not be confounded with F. L. Lewis, the member
of our mess. The latter, however, cannot live but a short time<span class="x-ebookmaker-pageno" id="pgepubid00048" title="[59]"><a id="Page_59"></a></span>
unless relief comes. Fine weather but very warm. The sandy
soil fairly alive with vermin. If this place is so bad at this time of
the year, what must it be in July, August and September? Every
man will die, in my estimation, but perhaps we may be relieved
before then. We’ll try and think so anyway. New prisoners die
off the fastest.</p>
<p class="calibre3">May 18.—We have some good singers in camp, and strange as it
may seem, a good deal of singing is indulged in. There are some
men that are happy as long as they can breathe, and such men
smoothe over many rough places here. God bless a man who can
sing in this place. A priest comes inside praying and chanting.
A good man to come to such a place. Performs his duty the same
to small-pox patients as to any other. Shall try and find out his
name. Some of the wells dug by the Yanks furnish passable water,
an improvement anyway on swamp water. Well water in great
demand and sells readily for such trinkets as the men have to dispose
of. Rebels building forts on the outside. Rebel officers
inside trying to induce shoemakers, foundrymen, carpenters and
wood choppers, to go out and work for the Confederacy. A very
few accepted the offer. Well, life is sweet, and can hardly blame
men for accepting the offer; still, I don’t want to go, neither do
ninety-nine out of every hundred. The soldiers here are loyal to
the cause.</p>
<p class="calibre3">May 19.—Nearly twenty thousand men confined here now. New
ones coming every day. Rations <em>very</em> small and <em>very</em> poor. The
meal that the bread is made out of is ground, seemingly, cob and
all, and it scourges the men fearfully. Things getting continually
worse. Hundreds of cases of dropsy. Men puff out of human
shape and are perfectly horrible to look at. Philo Lewis died to-day.
Could not have weighed at the time of his death more than
ninety pounds, and was originally a large man, weighing not less
than one hundred and seventy. Jack Walker, of the 9th Mich.
Cavalry, has received the appointment to assist in carrying out the
dead, for which service he receives an extra ration of corn bread.</p>
<p class="calibre3">May 20.—Hendryx sent me in to-day from the outside a dozen
small onions and some green tea. No person, on suddenly being
lifted from the lowest depths of misery to peace and plenty, and all
that money could buy, could feel more joyous or grateful than myself
for those things. As the articles were handed in through the
gate a crowd saw the transaction, and it was soon known that I<span class="x-ebookmaker-pageno" id="pgepubid00049" title="[60]"><a id="Page_60"></a></span>
had a friend on the outside who sent me in extras. I learn that a
conspiracy is being gotten up on the outside, in which Hendryx is
at the head, and they will try and overpower the guard and release
the prisoners. If Capt. Wirtz only knew it, he has a very dangerous
man in George Hendryx. Cram full of adventure, he will be
heard from wherever he is.</p>
<p class="calibre3">May 21.—Still good weather and hot, with damp nights. Dr.
Lewis lingers along in a miserable state of existence, and scurvy
and dropsy doing their worst. His old mess-mates at the 9th Michigan
regimental head-quarters little think of their favorite, story-telling,
good fellows’ condition now. We take as good care of him
as possible under the circumstances. Two men shot to-day by the
barbarians, and one of them has lain all the afternoon where he
fell.</p>
<p class="calibre3">May 22.—No news of importance. Same old story. Am now a
gallant washer-man. Battese, the Minnesota Indian, learn’t me in
the way of his occupation, made me a wash board by cutting creases
in a piece of board, and I am fully installed. We have a sign
out, made by myself on a piece of shingle: “WASHING.” We get
small pieces of bread for our labors. Some of the sick cannot eat
their bread, and not being able to keep clean, give us a job. Make
probably a pound of bread two or three days in the week. Battese
says: “I work, do me good; you do same.” Have many applications
for admission to the firm, and may enlarge the business.</p>
<p class="calibre3">May 23.—Rains very hard. Seems as if the windows of Heaven
had opened up, in fact the windows out all together. It’s a grand
good thing for the camp, as it washes away the filth and purifies
the air.</p>
<p class="calibre3">May 24.—Sherman coming this way, so said, towards Atlanta.
It is thought the cavalry will make a break for us, but even if they
do they cannot get us north. We are equal to no exertion. Men
busy to-day killing swallows that fly low; partly for amusement,
but more particularly for food they furnish. Are eaten raw before
hardly dead. No, thank you, I will take no swallow.</p>
<p class="calibre3">May 25.—One thousand new prisoners came to-day from near
Petersburg, Va. They give us encouraging news as to the termination
of the spring campaign. Gen. Burnside said in a speech to
his men that Petersburg would be taken in less than a month or
Mrs. Burnside would be a widow. Every one hopeful. Getting
warmer after the rain. Our squad has a very good well, and about
one-quarter water enough, of something a trifle better than swamp<span class="x-ebookmaker-pageno" id="pgepubid00050" title="[61]"><a id="Page_61"></a></span>
water. Man killed by the raiders near where we slept. Head all
pounded to pieces with a club. Murders an every day occurrence.</p>
<p class="calibre3">May 26.—For the last three days I have had nearly enough to eat
such as it is. My washing business gives me extra food. Have
taken in a partner, and the firm now is Battese, Ransom &amp; Co.
Think of taking in more partners, making Battese president, appointing
vice presidents, secretaries, &amp;c. We charge a ration of
bread for admittance. Sand makes a very good soap. If we could
get hold of a razor and open a barber shop in connection, our fortunes
would be made. We are prolonging Lewis’ life by trading
for luxuries to give him. Occasionally a little real meat soup, with
a piece of onion in it, etc. Am saving up capital to buy a pair of
shears I know of. Molasses given us to-day, from two to four
spoonfuls apiece, which is indeed a treat. Anything sweet or sour,
or in the vegetable line, is the making of us. We have taken to
mixing a little meal with water, putting in a little molasses and
setting it in the sun to sour. Great trouble in the lack of vessels in
which to keep it, and then too, after getting a dish partly well
soured, some poor prisoner will deliberately walk up and before
we can see him drink it all up. Men are fairly crazy for such
things.</p>
<p class="calibre3">May 27.—We twist up pieces of tin, stovepipe, &amp;c., for dishes.
A favorite and common dish is half of a canteen. Our spoons are
made of wood. Hardly one man in ten has a dish of any kind to
put his rations of soup or molasses in, and often old shoes, dirty
caps and the like are brought into requisition. Notwithstanding
my prosperity in business the scurvy is taking right hold of me.
All my old acquaintances visit us daily and we condole with one
another. Fresh beef given us to-day, but in very small quantities
with no wood or salt to put it into proper shape. No one can very
well object to raw beef, however. Great trouble is in getting it to
us before being tainted, I persistently let alone meat with even a
suspicion of rottenness; makes no difference with nearly all here.
We occasionally hear of the conspiracy of outside paroled Yankees.
Time will tell if it amounts to anything.</p>
<p class="calibre3">May 28.—No more news. It really seems as if we’re all to die
here. My mouth getting sore from scurvy and teeth loose. New
prisoners coming in every day and death rate increasing. I don’t
seem to get hardened to the situation and am shuddering all the
time at the sights. Rainy weather.</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00051" title="[62]"><a id="Page_62"></a></span></p>
<p class="calibre3">May 29.—Sabbath day but not a pleasant one. Nearly a thousand
just came in. Would seem to me that the rebels are victorious
in their battles. New men are perfectly thunderstruck at the hole
they have got into. A great many give right up and die in a few
weeks, and some in a week. My limbs are badly swollen with
scurvy and dropsy combined. Mouth also very sore. Battese digs
for roots which he steeps up and I drink. Could give up and die
in a short time but won’t. Have got living reduced to a science.</p>
<p class="calibre3">May 30.—Another thousand came to-day and from the eastern
army. Prison crowded. Men who came are from Siegel’s corps
in the Shenandoah Valley. The poor deluded mortals never heard
of Andersonville before. Well, they hear of it now. Charlie
Hudson, from some part of Ohio, took his canteen an hour ago
and went to the swamp for water. He has not returned for the
very good reason that he was shot while reaching up under the
dead line to get the freshest water. Some one has pulled the body
out of the water on to dry land where it will stay until to-morrow,
when it will be piled with perhaps forty others on the dead wagon,
carted off and buried like a dog. And this is the last of poor
Charlie, who has enlivened us many an evening with his songs and
stories. The Astor House Mess is very sad to-night.</p>
<p class="calibre3">May 31.—A rebel came inside to-day and enquired for me, in the
tenth squad, first mess. I responded, wondering and fearful as to
what they should want with me. Was happily surprised on going
to the gate to see Hendryx with something in his hand for me.
Seemed thunderstruck at my appearance and said I was looking
bad. He was looking better than when he went out. Had brought
me luxuries in the shape of ginger bread, onions and tea, and am
happy. Geo. is a brick. Says it is against orders to send anything
inside but he talked them over. Was afraid the raiders
would waylay me before reaching the mess but they did not.</p>
<p class="calibre3">June 1.—Reported that the 51st Virginia Regt. is here for the
purpose of conducting us north for exchange. Believe nothing of
the kind. Prisoners come daily. E. P. Sanders, Rowe and myself
carried our old friend Dr. Lewis to the hospital. He was immediately
admitted and we came away feeling very sad, knowing he
would live but a short time. The sick are not admitted until they
are near death, and then there is no hope for them. Rainy day.</p>
<p class="calibre3">June 2.—Another dark, stormy day. Raiders playing the very
devil. Muddy and sticky.</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00052" title="[63]"><a id="Page_63"></a></span></p>
<div class="calibre illowe20 figure" id="i_063">
<img alt="Battese, fellow prisoner" class="calibre6" id="id-7035492270250432613" src="Images/img0005.jpg"/>
<div class="caption figcaption">Battese, the Minnesota Indian.</div>
</div>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00053" title="[64]"><a id="Page_64"></a></span></p>
<p class="calibre3">June 3.—New prisoners say that an armistice has been agreed
upon for the purpose of effecting an exchange, and negotiating for
peace. It may be so, and the authorities had good reasons for
allowing us to stay here, but how can they pay for all the suffering?
And now some negro prisoners brought inside. They belong to
the 54th Massachusetts. Came with white prisoners. Many of the
negroes wounded, as, indeed, there are wounded among all who
come here now. No news from Hendryx or Lewis. Quite a number
going out after wood to cook with. Hot and wet.</p>
<p class="calibre3">June 4.—Have not been dry for many days. Raining continually.
Some men took occasion while out after wood, to overpower
the guard and take to the pines. Not yet been brought back. <em>Very</em>
small rations of poor molasses, corn bread and bug soup.</p>
<p class="calibre3">June 5.—Exchange rumors to the effect that transports are en-route
for Savannah for the purpose of taking us home. Stick right
to my washing however. A number of men taken out to be kept
as hostages—so said. Raiders rule the prison. Am myself cross
and feel like licking somebody, but Hendryx is gone and don’t
want to try to lick anybody else, fearing I might get licked myself.
Some fun fighting him as it didn’t make any difference which
licked.</p>
<p class="calibre3">June 6.—Eight months a prisoner to-day. A lifetime has been
crowded into these eight months. No rations at all. Am now a
hair cutter. Have <em>hired</em> the shears. Enough to eat but not the
right kind. Scurvy putting in its work, and symptoms of dropsy.
Saw Hendryx at the bake house up stairs window, looking over
the camp. Probably looking to see if he can locate his old comrades
among the sea of human beings. Wirtz comes inside no
more, in fact, does very few rebels. The place is too bad for
them.</p>
<p class="calibre3">June 7.—Heard to-day that Hendryx had been arrested and in
irons for inciting a conspiracy. Not much alarmed for him. He
will come out all right. Still rainy. Have hard work keeping my
diary dry. Nearly all the old prisoners who were captured with
me are dead. Don’t know of over 50 or 60 alive out of 800.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?65b074c9